import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import TableCustom from '../../../components/table/tableCustom'
import { useTranslation } from 'react-i18next'
import TableRowCommon from '../../../components/table/TableRowCommon'
import { notification_config_data, notification_config_list, NotificationsConfigApi } from '../../../api/notifications-config/notifications_config.api'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { dateToView } from '../../../utils/date.utils'
import StateComponents from '../../../components/state-component/StateComponents'
import { debouncedApiCall } from '../../../utils/app.utils'
import { icons } from '../../../assets/icons/icons'
import ModalCustom from '../../../components/modal/modalCustomCms'
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom'
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom'
import { alertError, alertSuccess } from '../../../components/alert/swal'

type Props = {}

const NotificationList: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");

    const [showModal, setShowModal] = useState<boolean>(false);
    const [is_edit, set_is_edit] = useState<boolean>(false);

    const [search, set_search] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [defaultFormState, setDefaultFormState] = useState<notification_config_data>({
        notification_config_name: "",
        send_after_event_date: "",
        send_at_event_date: false,
        send_before_event_date: "",
        send_now: false,
        via_email: false,
        via_web: false
    });
    const [formState, setFormState] = useState<notification_config_data>({
        notification_config_name: "",
        send_after_event_date: "",
        send_at_event_date: false,
        send_before_event_date: "",
        send_now: false,
        via_email: false,
        via_web: false
    })

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const handleChangeFormState = (field: keyof notification_config_data, value: any) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCancelEdit = () => {
        set_is_edit(false);
        setFormState(defaultFormState);
    }
    const handleClearData = () => {
        setFormState((prev) => ({
            id_notification_config: prev.id_notification_config,
            notification_config_name: prev.notification_config_name,
            send_after_event_date: "",
            send_at_event_date: false,
            send_before_event_date: "",
            send_now: false,
            via_email: false,
            via_web: false
        }))
    }
    const handleCloseModal = () => {
        setShowModal(false);
        setFormState({
            notification_config_name: "",
            send_after_event_date: "",
            send_at_event_date: false,
            send_before_event_date: "",
            send_now: false,
            via_email: false,
            via_web: false
        })
    }


    const headCells = [
        {
            id: "#",
            width: 2,
            disablePadding: false,
            align: "center",
            label: "ลำดับ"
        },
        {
            id: "fullname",
            width: 50,
            disablePadding: false,
            align: "start",
            label: "เรื่องการแจ้งเตือน"
        },
        // {
        //     id: "indentification_number",
        //     disablePadding: false,
        //     width: 75,
        //     align: "center",
        //     label: "ช่องทางการแจ้งเตือน",
        // },
        {
            id: "position",
            disablePadding: false,
            align: "center",
            width: 25,
            label: "เงื่อนไขการแจ้งเตือน",
        },
        {
            id: "leave_type",
            disablePadding: false,
            align: "center",
            width: 40,
            label: "ผู้ปรับปรุงล่าสุด",
        },
        {
            id: "request_period",
            disablePadding: false,
            align: "center",
            width: 75,
            label: "วันที่ปรับปรุงล่าสุด",
        },
        {
            id: "actions",
            disablePadding: false,
            align: "center",
            width: 20,
            class: matches && data?.length > 0,
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_leave,
            notification_config_name,
            modified_by,
            modified_date,
            id_notification_config,

            send_now,
            send_before_event_date,
            send_after_event_date,
            send_at_event_date
        } = objData;

        const objRenderData = {
            key: id_leave,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: `${no}` || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: notification_config_name || "-",
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: employee_no || "-",
                // },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: `
                    ${send_now ? "ทันที ," : ""} 
                    ${send_at_event_date ? `เมื่อถึงวันที่กำหนด ,` : ""} 
                    ${send_before_event_date ? `ล่วงหน้า ${send_before_event_date || "-"} วัน ,` : ""} 
                    ${send_after_event_date ? `เกินกำหนด ${send_after_event_date || "-"} วัน` : ""}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateToView(modified_date) : "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: <Box className="flex justify-center items-center">
                        <OptionsButtonCustom
                            enableView
                            disabledView={!id_notification_config}
                            onViewClick={() => {
                                setFormState({
                                    ...objData,
                                    send_before_event_date: send_before_event_date ? String(send_before_event_date) : "",
                                    send_after_event_date: send_after_event_date ? String(send_after_event_date) : ""
                                });
                                setDefaultFormState({
                                    ...objData,
                                    send_before_event_date: send_before_event_date ? String(send_before_event_date) : "",
                                    send_after_event_date: send_after_event_date ? String(send_after_event_date) : ""
                                });
                                setShowModal(true);
                            }}
                        />
                    </Box>
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;

    };

    const handleGetNotificationConfig = useCallback(async () => {
        let query: notification_config_list = {
            page: page,
            limit: pageLimit,
            // sortBy,
            // sortType
        }
        if (search) {
            query.search = search;
            query.page = 1;
        }
        dispatch(setLoading());
        await NotificationsConfigApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                const totalItems = res.data?.data?.meta?.totalItems || 0
                setData(response);
                setTotalItems(totalItems);
                // console.log(response, 'respose')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, search])

    const handleSubmit = async () => {
        const body: notification_config_data = {
            notification_config_name: formState.notification_config_name,
            send_at_event_date: formState.send_at_event_date,
            send_after_event_date: +formState.send_after_event_date,
            send_before_event_date: +formState.send_before_event_date,
            send_now: formState.send_now,
            via_email: !!formState.via_email,
            via_web: !!formState.via_web
        }
        if (formState.id_notification_config) {
            dispatch(setLoading());
            await NotificationsConfigApi.update_logs(formState.id_notification_config, body).then((res) => {
                if (res.status < 300) {
                    handleCloseModal();
                    handleCancelEdit();
                    handleGetNotificationConfig();
                    alertSuccess("อัพเดตการแจ้งเตือน", "อัพเดตการแจ้งเตือนเรียบร้อย")
                }
            }).catch((err) => {
                console.log(err)
                alertError("อัพเดตการแจ้งเตือน", "อัพเดตการแจ้งเตือน ไม่สำเร็จ")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }


    useEffect(() => {
        handleGetNotificationConfig();
    }, [handleGetNotificationConfig])


    return (
        <ContainerLayout
            title='ระบบแจ้งเตือน'
            content={
                <Box>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    placeholder: "ค้นหา",
                                    startAdornment: <Box>{<icons.SearchNormal />}</Box>,
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                }
                            }
                        ]}
                    />
                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                data?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>


                    {showModal && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={() => { }}
                            open
                            title='จัดการการแจ้งเตือน'
                            scrollBody
                            subTitle='กรุณาเลือกรายการที่ท่านต้องการ'
                            maxWidth='sm'
                            hintSubmitButton
                            custom_cancel_button={<></>}
                            form={
                                <Box py={2} className="w-full">
                                    <StateComponents
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    heading: "เรื่องการแจ้งเตือน",
                                                    value: formState.notification_config_name,
                                                    disabled: true
                                                }
                                            },
                                        ]}
                                    />
                                    <Typography my={2} variant='h6'>
                                        เงื่อนไขการแจ้งเตือน
                                    </Typography>

                                    <Box className="flex flex-col gap-4">
                                        <CheckBoxCustom
                                            disabled={!is_edit}
                                            checked={formState.via_web}
                                            setChecked={(st) => handleChangeFormState('via_web', st)}
                                            label='เว็บไซต์'
                                        />
                                        <CheckBoxCustom
                                            disabled={!is_edit}
                                            checked={formState.via_email}
                                            setChecked={(st) => handleChangeFormState('via_email', st)}
                                            label='อีเมล'
                                        />
                                    </Box>



                                    <Typography my={2} variant='h6'>
                                        เงื่อนไขการแจ้งเตือน
                                    </Typography>
                                    <Box className="flex flex-col gap-4">
                                        <CheckBoxCustom
                                            disabled={!is_edit}
                                            checked={formState.send_now}
                                            setChecked={(st) => handleChangeFormState('send_now', st)}
                                            label='ทันที'
                                        />
                                        <CheckBoxCustom
                                            disabled={!is_edit}
                                            checked={formState.send_at_event_date}
                                            setChecked={(st) => handleChangeFormState('send_at_event_date', st)}
                                            label='เมื่อถึงวันที่กำหนด'
                                        />
                                        <Box className="flex gap-4 justify-between items-center">
                                            <CheckBoxCustom
                                                disabled={!is_edit}
                                                label='ล่วงหน้า'
                                                checked={Boolean(formState.send_before_event_date)}
                                                setChecked={(st) => {
                                                    if (!st) {
                                                        handleChangeFormState('send_before_event_date', "");
                                                    } else {
                                                        handleChangeFormState('send_before_event_date', "1");
                                                    }
                                                }}
                                            />
                                            <StateComponents
                                                typeProps={[
                                                    {
                                                        seq: 1,
                                                        gridProps: {
                                                            xs: 12,
                                                        },
                                                        type: "TEXT-MASK",
                                                        fieldProps: {
                                                            mode: "full_number",
                                                            value: formState.send_before_event_date?.toString() || "",
                                                            onChange: (e) => handleChangeFormState('send_before_event_date', e.target.value),
                                                            disabled: !is_edit
                                                        }
                                                    },
                                                ]}
                                            />
                                        </Box>
                                        <Box className="flex gap-4 justify-between items-center">
                                            <CheckBoxCustom
                                                disabled={!is_edit}
                                                label='เกินกำหนด'
                                                checked={Boolean(formState.send_after_event_date)}
                                                setChecked={(st) => {
                                                    if (!st) {
                                                        handleChangeFormState('send_after_event_date', "");
                                                    } else {
                                                        handleChangeFormState('send_after_event_date', "1");
                                                    }
                                                }}
                                            />
                                            <StateComponents
                                                typeProps={[
                                                    {
                                                        seq: 1,
                                                        gridProps: {
                                                            xs: 12,
                                                        },
                                                        type: "TEXT-MASK",
                                                        fieldProps: {
                                                            mode: "full_number",
                                                            value: formState.send_after_event_date?.toString() || "",
                                                            onChange: (e) => handleChangeFormState('send_after_event_date', e.target.value),
                                                            disabled: !is_edit
                                                        }
                                                    },
                                                ]}
                                            />
                                        </Box>
                                    </Box>

                                    <Box mt={4}>
                                        {!is_edit && (
                                            <Box className="flex justify-center items-center gap-4">
                                                <Button fullWidth onClick={handleCloseModal} sx={{ borderRadius: "8px" }} variant='outlined'>ย้อนกลับ</Button>
                                                <Button fullWidth onClick={() => set_is_edit(true)} sx={{ borderRadius: "8px" }} variant='contained' color='secondary'>แก้ไข</Button>
                                                <Button fullWidth onClick={handleClearData} sx={{ borderRadius: "8px" }} variant='contained' color='error'>ลบ</Button>
                                            </Box>
                                        )}
                                        {is_edit && (
                                            <Box className="flex justify-center items-center gap-4">
                                                <Button fullWidth onClick={handleCancelEdit} sx={{ borderRadius: "8px" }} variant='outlined'>ยกเลิก</Button>
                                                <Button fullWidth onClick={handleSubmit} sx={{ borderRadius: "8px" }} variant='contained' color='success'> บันทึก</Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default NotificationList